import { render, staticRenderFns } from "./MAiReportWidget.vue?vue&type=template&id=397d33d2&scoped=true&lang=pug&"
import script from "./MAiReportWidget.vue?vue&type=script&lang=js&"
export * from "./MAiReportWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d33d2",
  null
  
)

export default component.exports